var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollect = function SvgCollect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 47 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M6.695 27.281 1 31.062 23.5 46 46 31.062l-5.695-3.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.695 27.281 1 31.062 23.5 46 46 31.062l-5.695-3.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M6.695 19.719 1 23.499l22.5 14.939L46 23.5l-5.696-3.781"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.695 19.719 1 23.499l22.5 14.939L46 23.5l-5.696-3.781"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Collect_svg__a)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M46 15.937 23.5 30.875 1 15.937 23.5 1 46 15.937"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M35.24 16.357 23.499 8.563l-11.741 7.794"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.544 20.139 23.5 16.125l-6.046 4.014"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Collect_svg__a",
    x1: 8.5,
    x2: 39.369,
    y1: 6,
    y2: 13.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgCollect;